<template>
  <div class="BOHTSUGERPAGE">
    <div class="bgFade" v-if="wxApliyPay">
      <div style="text-align:right" class="imgDiv">
        <img src="/static/img/wxApliyPayIcon.png" alt="">
        <img class="close" @click="wxApliyPay =false" src="/static/img/icon_close@2x.png" alt="">
      </div>
    </div>
    <div class="top">
      <div class="back" @click="back"><img src="/static/img/mns/back-btn.png" alt=""></div>
      <div class="title">
        充值
      </div>
    </div>
    <div class="sugerModel">
      <div class="quickList">
        <template v-for="item in sugerList">
          <div class="item" :class="[item.idx%3==0?'noMr':'',item.check?'on':'']" :key="item.key"
            @click="quickClick(item)">
            <p class="suger">
              <img src="/static/img/boheSuger/suger.png" alt="">
              <span>{{item.rechargeprice | filterMoney}}</span>
            </p>
            <p class="money">
              <span>￥{{item.mintsprice | filterMoney}}</span>
            </p>
          </div>
        </template>

      </div>
      <div class="sugerInput" @click="inputClick" :class="inputCheck?'on':''">
        <div class="show" v-if="amount">￥{{amount }}</div>
        <div class="show" v-else>（元）</div>
        <img src="/static/img/boheSuger/suger.png" alt="" class="icon">
        <input type="text" class="input" placeholder="输入自定义数额" v-model="amount" @input="inputIn">
      </div>
    </div>


    <div class="payCon">
      <div class="channelTitle">支付方式</div>
      <div class="payCheck" @click="selectPayFn(1)" v-if="alipaychannel != 0">
        <img src="/static/img/mns/apliy-icon.png" alt="" class="payIcon">
        <p class="text">
          <span>
            <!-- 支付宝支付 -->
            {{$t('mns.apliyPay')}}
          </span>
        </p>
        <img :src="paySourceType == 1 ?'/static/img/mns/check-icon.png':'/static/img/mns/select-icon.png'" alt=""
          class="selectIcon">
      </div>
      <div class="payCheck" @click="selectPayFn(2)" v-if="false">
        <img src="/static/img/payment/wepay.png" alt="" class="payIcon">
        <p class="text">
          <span>
            微信支付
          </span>
        </p>
        <img :src="paySourceType == 2 ?'/static/img/mns/check-icon.png':'/static/img/mns/select-icon.png'" alt=""
          class="selectIcon">
      </div>
      <div class="payCheck" @click="selectPayFn(3)" v-if="bankpaychannel != 0 && $store.state.token">
        <img src="/static/img/mns/bank-icon.png" alt="" class="payIcon">
        <p class="text">
          <span>
            {{$t('mns.bankPay')}}
            <!-- 银行卡支付 -->
          </span>
        </p>
        <img :src="paySourceType == 3 ?'/static/img/mns/check-icon.png':'/static/img/mns/select-icon.png'" alt=""
          class="selectIcon">
      </div>
    </div>
    <div class="paymentBtn" @click="surePayBtnFn()">充值</div>
    <div class="agreement" @click="goAgreement">充值即代表同意<span>《薄盒充值协议》</span></div>
    <div class="infoBox">
      <div class="infoTitle">充值说明</div>
      <p class="text">1.充值金额只能在薄盒App内使用，不能用于其他平台。</p>
      <p class="text">2.充值薄荷糖无使用期限，但充值后无法退款，不可提现。</p>
    </div>



    <!-- 您是否已完成本次支付？ -->
    <!-- 未支付 -->
    <!-- 我已支付 -->
    <d-confirm v-model="payResultModal" :loading="payResult" :content="$t('mns.isComplatePay')"
      :ok-text="$t('mns.noPay') " :cancel-text="$t('mns.hasPay') " ok-color="#f5f5f9" cancel-color="#1ce89e"
      @on-ok="payResultNo" @on-cancel="payResultSuccess">
    </d-confirm>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        alipaychannel: 0, //支付宝支付：2，原生支付宝；9，汇付支付宝；10，宝付支付宝；12，易宝支付宝支付；14，有赞支付宝
        bankpaychannel: 0, //快捷支付银行卡支付：6宝付银行卡，8，易宝绑卡支付；15，有赞快捷支付

        paypalpaychannel: 0,
        stripepaychannel: 0,

        paySourceType: 3, //1 支付宝 2微信 3银行卡
        payResultModal: false, //支付成功失败弹窗
        payResultError: 0, // 支付失败结果展示前提条件，状态接口轮询查询，int++ ，当值为5时提示支付失败
        payResult: false,
        loading: false,
        // apliyCheck: true,
        bankCheck: true,
        wxApliyPay: false, //微信内点击支付宝支付
        isFenZhang: '',
        callbackurl: '',
        isWeixin: false,
        detail: {
          totalPrice: 0,
        },
        bankPaySaleObj: { // 银行卡见面规则展示
          max: '',
          min: '',
          status: false,
        },

        sugerList: [],
        inputCheck: false,
        ruleid: undefined,
        amount: undefined,
        orderno: undefined,
      }
    },
    filters: {
      //分转元
      filterMoney(num) {
        return (num / 100).toFixed(0);
      },
      subStr(num) {
        return num.substring(0, 1);
      },
    },
    methods: {
      inputIn(event) {
        var value = event.target.value
        console.log(value, typeof value)
        if (value - 0 == 0) {
          this.amount = '';
          return
        }

        this.amount = value.replace(/[^0-9-]+/, '')
        console.log(this.amount, value.replace(/[^0-9-]+/, ''))
      },
      goAgreement() {
        this.$router.push({
          path: "/rechargeAgreement"
        })
      },
      inputClick() {
        this.inputCheck = true;
        this.ruleid = 0;
        this.sugerList.map(item => {
          return item.check = false;
        })
      },
      // 选择快捷充值按钮
      quickClick(obj) {
        this.sugerList.map(item => {
          if (item.id == obj.id) {
            this.ruleid = obj.id;
            return item.check = true;
          } else {
            return item.check = false;
          }
        })
        this.inputCheck = false;
        console.log(this.sugerList, this.ruleid)
      },
      getSugerRule() {
        this.$fetchql.Post("rechargerule/list").then((res) => {
          if (res.code == 0) {
            res.data.forEach((item, index) => {
              item.idx = index + 1;
              item.check = false
            })
            this.sugerList = res.data
          }
        })
      },
      selectPayFn(num) {
        this.paySourceType = num
      },
      back() {
        this.$router.replace({
          path: "/",
        });
      },

      // 用户点击支付成功按钮
      payResultNo() {
        this.$fetchql.Post("order/status", {
          orderType: 4,
          orderNo: this.$route.query.orderno
        }).then((res) => {
          if (res.code == 0) {
            // 返回订单状态 1.成功 2.失败 3.支付中
            if (res.data == 1) {
              this.$loading.hide();
              setTimeout(function () {
                this.$router.replace({
                  path: "/rechargeSuccess",
                  query: {
                    orderno: this.$route.query.orderno,
                    ordertype: 4,
                  },
                });
              }, 1000);
            } else if (res.data == 2) {
              this.$loading.hide();
              this.$toast({
                message: this.$i18nn.t('mns.transactionFailure'), //"交易失败",
              });
              setTimeout(function () {
                this.$router.replace({
                  path: "/",
                });
              }, 2000);
            } else if (res.data == 3) {
              this.$loading.hide();
              this.payResultModal = false;
            } else if (res.data == 0) {
              this.$loading.hide();
              this.payResultModal = false;
            }
          }
        })
      },
      // 用户点击支付成功按钮
      payResultSuccess() {
        this.$toast({
          message: this.$i18nn.t('mns.payWait'), //"支付中，请耐心等待！",
        });
        this.orderStatus(4)
      },
      //确认支付
      surePayBtnFn() {
        console.log(this.amount - 0)
        if (this.amount - 0 <= 0) return
        if ((this.orderno || this.$route.query.orderno) && this.amount - 0 <= 0) {
          if (this.paySourceType == 3) {
            this.banklist();
          } else if (this.paySourceType == 1) {
            this.alipay()
          }
          return
        }
        if (this.ruleid || this.amount) {
          this.$fetchql.Post("rechargeorder/create", {
            ruleid: this.ruleid,
            amount: (this.amount - 0) * 100
          }).then((res) => {
            if (res.code == 0) {
              this.orderno = res.data.orderno
              if (this.paySourceType == 3) {
                this.$router.replace({
                  query: {
                    ...this.$route.query,
                    orderno: res.data.orderno,
                    channel: "bank"
                  }
                })
                this.banklist();
              } else if (this.paySourceType == 1) {
                this.$router.replace({
                  query: {
                    ...this.$route.query,
                    orderno: res.data.orderno,
                    channel: "alipay"
                  }
                })
                this.alipay()
              }
            }
          })
        } else {
          this.$toast({
            message: '请选择充值金额！',
          });
        }
      },
      wxPay() {
        let that = this;
        if (that.isWeixin == true && that.isFenZhang == 2) {
          if (that.$route.query.code) {
            that.paySel();
          } else {
            location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4b8a96939fb0c77&redirect_uri=" +
              that.urlEcode +
              "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
          }
        } else {
          //汇付支付 则调用汇付支付封装的方法
          if (that.isFenZhang == 1) {
            that.hfFnWeixin(1);
          } else if (that.isFenZhang == 2) {
            that.paySel();
          }
        }

      },

      //汇付微信支付
      hfFnWeixin(ordertype) {
        let that = this;
        let paymentcreateData = {
          callbackurl: that.callbackurl,
          orderno: that.orderno || that.$route.query.orderno,
          ordertype: ordertype,
          paychannel: "wx_lite",
        };
        // that.Indicator.open({
        //   text: "加载中...",
        //   spinnerType: "fading-circle",
        // });
        that.$loading.show();
        that.$fetchql
          .Post("div/paymentcreate", paymentcreateData)
          .then((result) => {
            console.log("汇付支付返回信息");
            console.log(result);
            // that.Indicator.close();
            that.$loading.hide();
            if (result.code == 0) {
              location.href = result.data.expend.wx_h5_pay_url;
            }
          });
      },
      //支付宝 alipay
      alipay() {
        let that = this;
        // "alipaychannel":支付宝支付：2，原生支付宝；9，汇付支付宝；10，宝付支付宝；12，易宝支付宝支付；14，有赞支付宝
        if (that.isWeixin) {
          that.wxApliyPay = true
          setTimeout(() => {
            function getStatus() {
              if (that.orderno || that.$route.query.orderno) {
                that.$fetchql.Post("order/status", {
                    orderType: 4,
                    orderNo: that.orderno || that.$route.query.orderno
                  })
                  .then((res) => {
                    if (res.code == 0) {
                      // 返回订单状态 1.成功 2.失败 3.支付中
                      if (res.data == 3 && that.wxApliyPay) {
                        that.wxApliyPay = false;
                        that.payResultModal = true;
                      } else {
                        setTimeout(() => {
                          getStatus();
                        }, 1500)
                      }
                    }
                  })
              }
            }
            getStatus();
          }, 10000)
          return
        }

        //1原生2宝付3汇付4易宝
        if (that.alipaychannel != 2) {
          setTimeout(function () {
            that.orderStatus(4);
          }, 3000);
          if (that.alipaychannel == 12) {
            that.ybAlipay();
          } else {
            that.dealAlipay();
          }
        } else if (that.alipaychannel == 2) {
          this.paySel();
        }
      },
      //查询订单状态
      orderStatus(orderType) {
        let that = this;
        that.payResultModal = false;
        that.payResultError++;
        that.$loading.show();
        if (that.orderno || that.$route.query.orderno) {
          that.$fetchql.Post("order/status", {
            orderType: orderType,
            orderNo: that.orderno || that.$route.query.orderno
          }).then((res) => {
            if (res.code == 0) {
              // 返回订单状态 1.成功 2.失败 3.支付中
              if (res.data == 1) {
                that.$loading.hide();
                setTimeout(function () {
                  that.$router.replace({
                    path: "/rechargeSuccess",
                  });
                }, 1000);
              } else if (res.data == 2) {
                that.$loading.hide();
                that.$toast({
                  message: that.$i18nn.t('mns.payError'), //"交易失败",
                });
                setTimeout(function () {
                  that.$router.replace({
                    path: "/",
                  });
                }, 2000);
              } else if (res.data == 3) {
                setTimeout(() => {
                  if (that.payResultError >= 3) {
                    // that.$toast({
                    //   message: "交易失败",
                    // });
                    that.$loading.hide();
                  } else {
                    that.orderStatus(orderType);
                  }
                }, 3000)
                that.$loading.show();
              } else if (res.data == 0) {
                that.$loading.hide();
                that.payResultModal = false;
              }
            }

          })
        }

      },
      //银行卡列表
      banklist() {
        let that = this;
        that.$fetchql.Post("bank/list").then((res) => {
          if (res.code == 0) {
            if (res.data.length == 0) {
              that.$router.push({
                path: "/addBank",
                query: {
                  source: "/boheSuger",
                  orderno: that.orderno || that.$route.query.orderno,
                }
              })
            } else {
              that.$router.push({
                path: "/bankList",
                query: {
                  source: "/boheSuger",
                  orderno: that.orderno || that.$route.query.orderno,
                }
              })
            }
            // that.banklistLength = res.data.length

          }
        })
      },
      // 查询域名订单
      getUserDomainOrder() {
        this.$fetchql.Post('user/domain/order/query', {
          orderNo: this.$route.query.orderno
        }).then((res) => {
          if (res.code != 0) return;
          this.detail = res.data;
        });
      },
      //域名支付
      paySel() {
        let that = this;
        let data = {
          orderno: that.orderno || that.$route.query.orderno,
          buyerid: '',
          paychannel: 2,
          bankid: 0,
        };
        that.$fetchql.Post("order/pay/v1", data).then((result) => {
          console.log(result.data);
          if (result.code == 0) {
            window.location.href = result.data.resulturl
          } else {
            that.$toast({
              message: result.message,
            });
          }
        });
      },
      //易宝支付宝支付
      ybAlipay() {
        let that = this;
        that.$fetchql.Post('order/pay/v1', {
          orderno: that.orderno || that.$route.query.orderno,
          paychannel: 12,
        }).then(res => {
          if (res.code) location.href = res.data
        })
      },
      //汇付、宝付支付宝支付
      dealAlipay() {
        let that = this;
        var orderdata = {
          orderno: that.orderno || that.$route.query.orderno,
          orderPayType: 4,
          paychannel: 'alipay_pub',
          clientchannel: 2
        }
        if (that.isFenZhang == 2) {
          orderdata.paychannel = '2'
          location.href =
            "alipays://platformapi/startapp?saId=10000007&qrcode=https://" + location.host + "/payMiddle?orderdata=" +
            JSON
            .stringify(orderdata)
        } else if (that.isFenZhang == 3) {
          orderdata.paychannel = 'alipay_pub'
          location.href =
            "alipays://platformapi/startapp?saId=10000007&qrcode=https://" + location.host + "/payMiddle?orderdata=" +
            JSON
            .stringify(orderdata)
        }
        setTimeout(() => {
          location.href = that.callbackurl;
        }, 3000);
      },
      // 通过订单号查询相关信息
      getOrderInfoObj() {
        this.$fetchql.Post('order/info', {
          orderNo: this.$route.query.orderno,
        }).then(res => {
          if (res.code != 0) return
          this.userName = res.data.customer.name;
          this.avatarImg = this.$baseUrl + res.data.customer.avatar;
          this.totalPrice = res.data.realPrice;
          this.detail = Object.assign(this.detail, res.data)
        })
      },
    },
    beforeDestroy() {},
    mounted() {
      this.getSugerRule();
      this.callbackurl = location.href;


      if (this.$route.query.orderno) {
        this.getOrderInfoObj();
        this.orderStatus(4);
      }

      this.$fetchql.Get("pay/channel/v1").then((response) => {
        if (response.code == 0) {
          // "wechatpaychannel": 0,        //微信支付：1，原生微信；5，汇付微信；11，宝付微信支付；13，有赞微信支付   暂时不调,时间:2022-07-14
          // "alipaychannel": 2,            //支付宝支付：2，原生支付宝；9，汇付支付宝；10，宝付支付宝；12，易宝支付宝支付；14，有赞支付宝
          // "bankpaychannel": 8        //快捷支付银行卡支付：6宝付银行卡，8，易宝绑卡支付；15，有赞快捷支付

          this.alipaychannel = response.data.alipaychannel;
          this.bankpaychannel = response.data.bankpaychannel;

          this.paypalpaychannel = response.data.paypalpaychannel;
          this.stripepaychannel = response.data.stripepaychannel;

          if (this.$route.query.orderno) {
            this.$fetchql.Post("order/status", {
                orderType: 4,
                orderNo: this.$route.query.orderno
              })
              .then((res) => {
                if (res.code == 0 && res.data != 0) {
                  this.payResultModal = true;
                }
              })
          }
          //原生 微信，暂时不调，时间:2022-07-14
          // if (response.data == 1) {
          //   if (this.isWeixin == true) {
          //     //  微信授权后 获取到code 直接调起微信支付
          //     if (this.$route.query.code) {
          //       this.paySel("2", 1, true, this.$route.query.code);
          //     }
          //   }
          // }
        }
      });
      var ua = window.navigator.userAgent.toLowerCase();

      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.isWeixin = true;
        if ((this.orderno || this.$route.query.orderno) && this.$route.query.channel == 'alipay') {
          this.alipay();
        }
      } else {
        this.isWeixin = false;
      }

    },
    created() {

    },
  }

</script>
<style scoped lang="less">
  .BOHTSUGERPAGE {
    padding: 0 15px;

    .bgFade {
      width: 100%;
      height: 100vh;
      background: rgba(0, 0, 0, 0.85);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 2600;

      .imgDiv {
        width: 199.5px;
        float: right;

        .close {
          display: block;
          width: 20px;
          height: 20px;
          margin: 10px auto 0;
        }

        img {
          width: 199.5px;
          height: 105px;
          margin-right: 23px;
        }
      }

    }

    .top {
      position: relative;
      height: 40px;
      margin-top: 10px;

      .back {
        position: absolute;
        left: 0;
        top: 13px;
        width: 26px;
        height: 10px;

        img {
          width: 26px;
          height: 10px;
        }
      }

      .title {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-weight: 500;
        color: #FFFFFF;
        font-size: 15px;
      }
    }

    .sugerModel {
      overflow: hidden;
      margin-top: 25px;

      .quickList {
        display: flex;
        flex-wrap: wrap;

        .item {
          overflow: hidden;
          width: 109px;
          min-width: 109px;
          height: 90px;
          background: rgba(22, 22, 22, 1);
          border-radius: 4px;
          margin-bottom: 9px;
          margin-right: 9px;
          box-sizing: border-box;
          border: 1px solid rgba(22, 22, 22, 1);

          &.noMr {
            margin-right: 0;
          }

          &.on {
            border: 1px solid rgba(28, 232, 158, 1);
          }

          .suger {
            text-align: center;
            margin-top: 22px;
            margin-bottom: 0;

            img {
              display: inline-block;
              vertical-align: middle;
              width: 16px;
              height: 16px;
            }

            span {
              display: inline-block;
              vertical-align: middle;
              font-size: 18px;
              font-family: SourceHanSansCN-Bold, SourceHanSansCN;
              font-weight: bold;
              color: #FFFFFF;
              margin-left: 4px;
            }
          }

          .money {
            margin-top: 5px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #999999;
            text-align: center;
          }
        }
      }


      .sugerInput {
        width: 345px;
        height: 45px;
        box-sizing: border-box;
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 4px;
        padding: 0 15px;

        &.on {
          border: 1px solid rgba(28, 232, 158, 1);
        }

        .show {
          float: right;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #999999;
          margin-top: 13px;
        }

        .icon {
          float: left;
          width: 16px;
          height: 16px;
          margin-top: 13px;
        }

        .input {
          float: left;
          height: 42px;
          margin-left: 6px;
          background: none;
          border: none;
          font-size: 18px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #FFFFFF;
          width: 200px;

          &::-webkit-input-placeholder {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            padding-top: 2px;
            line-height: normal;
          }
        }
      }
    }


    .payCon {
      overflow: hidden;
      margin-top: 45px;

      .channelTitle {
        font-size: 16px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        margin-bottom: 26px;
        color: #FFFFFF;
      }

      .payCheck {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin-bottom: 30px;

        p.text {
          margin: 0;
          padding: 0;
          display: inline-block;
          vertical-align: middle;
        }

        span {

          &.sale {
            font-size: 11px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #FF607A;
            letter-spacing: 0;
          }
        }

        .payIcon {
          width: 17px;
          height: 17px;
          vertical-align: middle;
          margin-right: 10px;
        }

        .selectIcon {
          width: 17px;
          height: 17px;
          vertical-align: middle;
          margin-top: 1px;
          float: right;
        }
      }

      .payCheck:last-child {
        margin-bottom: 0px;
      }
    }

    .infoBox {
      margin-top: 25px;

      .infoTitle {
        font-size: 14px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
        margin-bottom: 11px;
      }

      .text {
        font-size: 12px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #999999;
        margin: 0;
        line-height: 18px;

      }
    }

    .paymentBtn {
      background: url(/static/img/payment/btn-on.png);
      background-size: 100% 100%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #013925;
      letter-spacing: 1px;
      margin-top: 47px;

    }

    .agreement {
      margin-top: 16px;
      font-size: 11px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 100;
      color: #FFFFFF;
      text-align: center;

      span {
        color: #1CE89E;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/boheSuger/index.vue